import React from 'react';
import { func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockSubscriptionForm.module.css';
import { Form as FinalForm } from 'react-final-form';
import { Form, SubscriptionForm } from '../../../../components';

const FieldMedia = props => {
  const { className, media, sizes, options } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
};

const BlockSubscriptionForm = props => {
  const {
    blockId,
    className,
    rootClassName,
    mediaClassName,
    textClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
    isFooter,
  } = props;
  const classes = classNames(css.subscriptionBlock, rootClassName || css.root, className, {
    [css.subscriptionBlockFooter]: isFooter,
  });
  const hasTextComponentFields = hasDataInFields([title, text, callToAction], options);

  const submitLogin = payload => {
    console.log(payload);
  };

  const inProgress = false;

  return (
    <BlockContainer id={blockId} className={classes}>
      <SubscriptionForm
        title="Let’s keep in touch."
        altTitle="Our business is about boosting yours."
        subtitle="By clicking Subscribe, I agree to receive exclusive offers & promotions, news & reviews, and personalized tips for buying and selling on BowTackle"
        onSubmit={submitLogin}
        inProgress={inProgress}
        isFooter={isFooter}
      />
    </BlockContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

BlockSubscriptionForm.defaultProps = {
  className: null,
  rootClassName: null,
  mediaClassName: null,
  textClassName: null,
  ctaButtonClass: null,
  title: null,
  text: null,
  callToAction: null,
  media: null,
  responsiveImageSizes: null,
  options: null,
};

BlockSubscriptionForm.propTypes = {
  blockId: string.isRequired,
  className: string,
  rootClassName: string,
  mediaClassName: string,
  textClassName: string,
  ctaButtonClass: string,
  title: object,
  text: object,
  callToAction: object,
  media: object,
  responsiveImageSizes: string,
  options: propTypeOption,
};

export default BlockSubscriptionForm;
